import { defaultSvgProps, SvgProps } from "../type/props";

export const DataDownloadCloseIcon = (props?: SvgProps) => {
  const { width, height, fill, stroke, style } = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: "none",
    stroke: "currentColor",
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      style={style}
    >
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
};
